import React from "react";
import Item from "./Item";


export default function EventScale(props) {
    let cards = [];
    props.markup.result.map(element => {
        const body = [[], []];
        let warn = "";

        if (element.anomalies) {
            for (let i of Object.keys(element.anomalies)) {
                if (element.anomalies[i]) {
                    body[0].push(i);
                }
                warn += String(element.anomalies[i]);
            }
        } else {
            body[0] = element.warn || [];
            body[1] = element.ok || [];
        }
        //console.log(body)
        cards.push(<Item
            token={props.token}
            key={`${element.start_time}-${element.end_time}`}
            source="webcam"
            from={element.start_time}
            to={element.end_time}
            duration={element.end_time - element.start_time}
            body={body}
            setViolation={props.setViolation}
        />);
    })

    //Sorting by duration of violation
    cards.sort(function(a,b){return (b.props.duration - a.props.duration)});
    return (<>
      {cards}
    </>
    );
}
